(function ($) {
  'use strict';

  /**
   * Sliders
   * ---
   * Splide.js [https://splidejs.com/]
   */

  // RTL Helper
  var is_rtl = document.dir === 'rtl';
  var slider_dir = is_rtl ? 'rtl' : 'ltr';

  // Reduced Motion Helper
  var mql_reduced_motion = window.matchMedia( '(prefers-reduced-motion: reduce)' );
  var is_reduced_motion = mql_reduced_motion === true
    || mql_reduced_motion.matches === true;


  /**
   * Card Sliders
   * - 3 Cols
   * - Centered Slides
   */

  var slider_cards = document.querySelectorAll( '.js-slider-cards' );

  if ( slider_cards && slider_cards.length ) {
    slider_cards.forEach(function ( this_slider ) {

      var this_slides = this_slider.querySelectorAll( '.splide__slide' );
      var slider_type = 'slide';
      var slider_arrows = false;
      var is_disabled = true;

      if ( this_slides.length >= 3 ) {
        slider_type = 'loop';
        slider_arrows = true;
        is_disabled = false;
      }

      new Splide( this_slider, {
        // Slider Config
        type: slider_type,
        arrows: slider_arrows,
        perPage: 1,
        focus: 'center',
        autoWidth: true,
        // Styles
        gap: '1.25rem',
        padding: '4.375rem',
        direction: slider_dir,
        destroy: is_disabled,
        breakpoints: {
          760: {
            destroy: false,
            type: 'loop',
            arrows: true,
          },
        },
      }).mount();
    });
  }


  /**
   * Generic Quote Slider
   */

  var slider_quotes = document.querySelectorAll( '.js-slider-quotes' );

  if ( slider_quotes && slider_quotes.length ) {
    slider_quotes.forEach(function ( this_slider ) {
      new Splide( this_slider, {
        // Slider Config
        type: 'loop',
        perPage: 1,
        arrows: true,
        focus: 'center',
        autoWidth: true,
        // Styles
        gap: '1.25rem',
        direction: slider_dir,
        // MQ Breakpoints (Max-Width, from mobile -> desktop)
        breakpoints: {
          760: {
            perPage: 1,
            arrows: false,
          },
        },
      }).mount();
    });
  }


  /**
   * Video Slider
   */

  var slider_videos = document.querySelectorAll( '.js-slider-videos' );

  if ( slider_videos && slider_videos.length ) {
    slider_videos.forEach(function ( this_slider ) {
      new Splide( this_slider, {
        // Slider Config
        type: 'loop',
        perPage: 1,
        arrows: true,
        focus: 'center',
        autoWidth: true,
        // Styles
        gap: '1.25rem',
        direction: slider_dir,
        // MQ Breakpoints (Max-Width, from mobile -> desktop)
        breakpoints: {
          760: {
            perPage: 1,
            arrows: false,
          },
        },
      }).mount();
    });
  }



  /**
   * Crew Testimonial Slider
   */

  var slider_crew_quotes = document.querySelectorAll( '.js-slider-crew-quotes' );

  if ( slider_crew_quotes && slider_crew_quotes.length ) {
    slider_crew_quotes.forEach(function ( this_slider ) {
      new Splide( this_slider, {
        // Slider Config
        type: 'loop',
        perPage: 2,
        // Styles
        gap: '1.25rem',
        direction: slider_dir,
        // MQ Breakpoints (Max-Width, from mobile -> desktop)
        breakpoints: {
          960: {
            perPage: 1,
          },
        },
      }).mount();
    });
  }


  /**
   * Image Marquee Slider
   * - Auto-slider with controls disabled
   */

  var slider_image_grid = document.querySelectorAll( '.js-slider-image-marquee' );
  var autoScrollConfig = false;

  if ( ! is_reduced_motion ) {
    autoScrollConfig = {
      speed: 0.5,
      pauseOnHover: false,
      pauseOnFocus: false,
      useToggleButton: true,
    };
  }

  if ( slider_image_grid && slider_image_grid.length ) {
    slider_image_grid.forEach(function ( this_slider ) {
      new Splide( this_slider, {
        // Slider Config
        type: 'loop',
        autoWidth: true,
        autoScroll: autoScrollConfig,
        direction: slider_dir,
        // Controls
        arrows: false,
        pagination: false,
        drag: false,
        // Styles
        gap: '1.25rem',
        padding: '4.375rem',
      }).mount( window.splide.Extensions );
    });
  }


  /**
   * Full Width Section Slider
   */

  var slider_full_sections = document.querySelectorAll( '.js-slider-full-sections' );

  if ( slider_full_sections && slider_full_sections.length ) {
    slider_full_sections.forEach(function ( this_slider ) {
      var this_slides = this_slider.querySelectorAll( '.splide__slide' );
      var slider_type = 'slide';
      var slider_arrows = false;
      var is_disabled = true;

      if ( this_slides.length > 1 ) {
        slider_type = 'loop';
        slider_arrows = true;
        is_disabled = false;
      }

      new Splide( this_slider, {
        // Slider Config
        type: slider_type,
        perPage: 1,
        // Controls
        arrows: slider_arrows,
        pagination: true,
        drag: false,
        // Styles
        gap: '1.25rem',
        padding: '4.375rem',
        direction: slider_dir,
        destroy: is_disabled,
        // MQ Breakpoints (Max-Width, from mobile -> desktop)
        breakpoints: {
          760: {
            gap: '0.625rem',
            padding: '1.375rem',
          },
        },
      }).mount();
    });
  }


  /**
   * Post Sliders
   * - 3 Cols
   * - Centered Slides
   */
  
  var slider_posts = document.querySelectorAll( '.js-slider-posts' );

  if ( slider_posts && slider_posts.length ) {
    slider_posts.forEach(function ( this_slider ) {
      new Splide( this_slider, {
        type: 'loop',
        perPage: 3,
        // Controls
        arrows: false,
        pagination: true,
        gap: '1.25rem',
        padding: '4.375rem',
        direction: slider_dir,
        // MQ Breakpoints (Max-Width, from mobile -> desktop)
        breakpoints: {
          760: { perPage: 1 }
        },
      }).mount();
    });
  }


  /**
   * Card Sliders
   * - 3 Cols
   * - Centered Slides
   */

  var slider_tiktok = document.querySelectorAll( '.js-slider-tiktok-embeds' );

  if ( slider_tiktok && slider_tiktok.length ) {
    slider_tiktok.forEach(function ( this_slider ) {
      new Splide( this_slider, {
        // Slider Config
        type: 'slide',
        perPage: 3,
        arrows: false,
        // Styles
        gap: '1.875rem',
        padding: '4.375rem',
        direction: slider_dir,
        breakpoints: {
          760: {
            perPage: 1,
            arrows: true,
          },
        },
      }).mount();
    });
  }


  /**
   * Auto-Width Slider
   */

  var auto_width_slider = document.querySelectorAll( '.js-auto-width-slider' );

  if ( auto_width_slider && auto_width_slider.length ) {
    auto_width_slider.forEach(function ( this_slider ) {
      new Splide( this_slider, {
        // Slider Config
        type: 'loop',
        autoWidth: true,
        // Styles
        gap: '1.25rem',
        padding: '4.375rem',
        direction: slider_dir,
      }).mount();
    });
  }


  /**
   * Post Navigation Slider
   */

  var slider_post_navigation = document.querySelectorAll( '.js-slider-post-navigation' );

  if ( slider_post_navigation && slider_post_navigation.length ) {
    slider_post_navigation.forEach(function ( this_slider ) {
    
      // Move pagination inside arrows container
      function repositionPagination(sliderElement) {
        var pagination = sliderElement.querySelector('.splide__pagination');
        var arrowsContainer = sliderElement.querySelector('.splide__arrows');
      
        if (pagination && arrowsContainer) {
          arrowsContainer.appendChild(pagination);
        
          pagination.classList.add('pagination-repositioned');
        }
      }
    
      function initPostNavSlider() {
        // Only initialize on mobile/tablet
        if ( window.innerWidth <= 760 ) {
          var this_slides = this_slider.querySelectorAll( '.splide__slide' );
          var start_index = 0;
        
          // Find the current slide and start there
          this_slides.forEach(function(slide, index) {
            if (slide.classList.contains('current-slide')) {
              start_index = index;
            }
          });
        
          // Make sure the slider is visible before initializing
          this_slider.style.visibility = 'visible';
          this_slider.style.opacity = '1';
        
          try {
            var splideInstance = new Splide( this_slider, {
              type: 'slide', // Don't loop since we have specific prev/current/next
              perPage: 1,
              start: start_index,
              arrows: true,
              pagination: true,
              drag: true,
              keyboard: true,
              gap: '1.25rem',
              padding: '0',
              direction: slider_dir,
              autoWidth: false,
              fixedWidth: false,
              height: 'auto',
              lazyLoad: false,
              preloadPages: 1,
            });
          
            // Handle pagination repositioning after mount
            splideInstance.on('mounted', function() {
              repositionPagination(this_slider);
            
              // Ensure visibility after mount and repositioning
              setTimeout(function() {
                this_slider.style.visibility = 'visible';
                this_slider.style.opacity = '1';
              }, 50);
            });
          
            // Handle pagination repositioning after refresh/resize
            splideInstance.on('refresh', function() {
              repositionPagination(this_slider);
            });
          
            // Mount the slider
            splideInstance.mount();
          
            // Store instance for cleanup
            this_slider.splideInstance = splideInstance;
          
          } catch (error) {
            //console.error('Error initializing post navigation slider:', error);
            // Fallback: make sure it's still visible even if slider fails
            this_slider.style.visibility = 'visible';
            this_slider.style.opacity = '1';
          }
        }
      }
    
      // Cleanup existing slider
      function cleanupSlider() {
        if (this_slider.splideInstance) {
          try {
            this_slider.splideInstance.destroy();
          } catch (e) {
            console.warn('Error destroying slider:', e);
          }
          this_slider.splideInstance = null;
        }
      }
    
      // Initialize immediately if DOM is ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initPostNavSlider);
      } else {
        // DOM is already loaded
        setTimeout(initPostNavSlider, 100);
      }
    
      // Re-initialize on window resize (with debouncing)
      var resizeTimeout;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
          cleanupSlider();
          initPostNavSlider();
        }, 250);
      });
    
    });
  }


  // Related Menu Items, mobile only slider

  document.addEventListener('DOMContentLoaded', function() {
    var mobileCarousels = document.querySelectorAll('.js-mobile-carousel');
    var splideInstances = [];

    function initMobileCarousels() {
      if (window.innerWidth <= 760) {
        mobileCarousels.forEach(function(carousel, index) {
          if (!splideInstances[index]) {
            // Convert to Splide structure on mobile only
            var ul = carousel.querySelector('ul');
            var items = carousel.querySelectorAll('li');
                    
            // Wrap in Splide structure
            carousel.classList.add('splide');
            carousel.innerHTML = '<div class="splide__track"><ul class="splide__list"></ul></div>';
            var newList = carousel.querySelector('.splide__list');
                  
            // Move items and add splide__slide class
            items.forEach(function(item) {
              item.classList.add('splide__slide');
              newList.appendChild(item);
            });
                    
            // Initialize Splide
            splideInstances[index] = new Splide(carousel, {
              type: 'loop',
              perPage: 1,
              arrows: false,
              pagination: true,
              gap: '1.25rem',
              padding: '2rem'
            }).mount();
          }
        });
      } else {
        // Restore original structure on desktop
        splideInstances.forEach(function(instance, index) {
          if (instance) {
            instance.destroy();
            splideInstances[index] = null;
                    
            var carousel = mobileCarousels[index];
            var items = carousel.querySelectorAll('.splide__slide');
                    
            // Restore original structure
            carousel.classList.remove('splide');
            carousel.innerHTML = '<ul class="l-grid l-grid--3-col l-grid--justify-center" role="list"></ul>';
            var newList = carousel.querySelector('ul');
                    
            items.forEach(function(item) {
              item.classList.remove('splide__slide');
              item.classList.add('l-grid-item');
              newList.appendChild(item);
            });
          }
        });
      }
    }

    // Initialize on load
    initMobileCarousels();

    // Handle resize
    var resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(initMobileCarousels, 250);
    });
  });


  // Related Stories Carousel, mobile only
  document.addEventListener('DOMContentLoaded', function() {
    var storiesCarousels = document.querySelectorAll('.js-mobile-stories-carousel');
    var splideInstances = [];

    function initStoriesCarousels() {
      if (window.innerWidth <= 760) {
        storiesCarousels.forEach(function(carousel, index) {
          if (!splideInstances[index]) {
            // Convert to Splide structure on mobile only
            var columnsDiv = carousel.querySelector('.l-columns');
            var items = carousel.querySelectorAll('.l-column-item');
                    
            // Wrap in Splide structure
            carousel.classList.add('splide');
            carousel.innerHTML = '<div class="splide__track"><ul class="splide__list"></ul></div>';
            var newList = carousel.querySelector('.splide__list');
                    
            // Move items and add splide__slide class
            items.forEach(function(item) {
              var li = document.createElement('li');
              li.classList.add('splide__slide');
              li.appendChild(item);
              newList.appendChild(li);
            });
                    
            // Initialize Splide
            splideInstances[index] = new Splide(carousel, {
              type: 'loop',
              perPage: 1,
              arrows: false,
              pagination: true,
              gap: '1.25rem',
              padding: '2rem'
            }).mount();
          }
        });
      } else {
        // Restore original structure on desktop
        splideInstances.forEach(function(instance, index) {
          if (instance) {
            instance.destroy();
            splideInstances[index] = null;
                    
            var carousel = storiesCarousels[index];
            var slides = carousel.querySelectorAll('.splide__slide');
                    
            // Restore original structure
            carousel.classList.remove('splide');
                    
            // Determine column class based on number of items
            var itemCount = slides.length;
            var columnClass = 'l-columns--' + itemCount;
                    
            carousel.innerHTML = '<div class="l-columns ' + columnClass + '"></div>';
            var newColumnsDiv = carousel.querySelector('.l-columns');
                    
            slides.forEach(function(slide) {
              var item = slide.querySelector('.l-column-item');
              if (item) {
                newColumnsDiv.appendChild(item);
              }
            });
          }
        });
      }
    }

    // Initialize on load
    initStoriesCarousels();

    // Handle resize
    var resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(initStoriesCarousels, 250);
    });
  });


})(jQuery);
